// Which sponsor is on the screen in each slot. Match day sponsors take every other slot (and every slot
// when there are no others); the rest take turns in between. Each group cycles in its own order.
import type { MatchSponsor } from './match';

export interface SponsorSlot { sp: MatchSponsor; matchday: boolean; credit?: boolean }

export function sponsorAt(list: SponsorSlot[], i: number): SponsorSlot | null {
  if (!list.length) return null;
  const md = list.filter(x => x.matchday), rest = list.filter(x => !x.matchday);
  if (md.length && rest.length) return i % 2 === 0 ? md[(i >> 1) % md.length] : rest[(i >> 1) % rest.length];
  return list[i % list.length];
}

/** The Matchlight credit takes one slot in every CREDIT_EVERY (about once a minute at 8 seconds a slot). */
export const CREDIT_EVERY = 6;

/**
 * Like sponsorAt, with the Matchlight credit (when it is on) in the last of every CREDIT_EVERY slots, or in
 * every slot when the club shows no sponsors. The club's sponsors keep their own order in the slots between.
 */
export function slotAt(list: SponsorSlot[], i: number, credit: SponsorSlot | null): SponsorSlot | null {
  if (!credit) return sponsorAt(list, i);
  if (!list.length || i % CREDIT_EVERY === CREDIT_EVERY - 1) return credit;
  return sponsorAt(list, i - Math.floor(i / CREDIT_EVERY));
}
